module.exports = __webpack_public_path__ + "static/media/TMT 2c2.4e5aff3f.jpg";